import { Flex, Heading, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import "../../../CustomTextArea/rte.css";
import PreviewTemplateChart from "../../../PlanTemplates/PreviewTemplateChart";

const FlexibleAssessmentPreview = ({ measure, key1, key2 }) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column">
      <Flex.Item>
        <Heading level="h3">{t("results.flexibleCanvasAssessment")}</Heading>
      </Flex.Item>
      <Flex.Item margin="small 0 small large">
        <Text>{measure.description}</Text>
      </Flex.Item>
      <Flex.Item overflowX="hidden" padding="small 0 small large">
        <PreviewTemplateChart
          bindto={"preview-section-" + key1 + "-measure-" + key2 + "-course"}
          masteryResults={"true"}
          title={t("assessment.masteryAvgCourse")}
        />
      </Flex.Item>
      <Flex.Item overflowX="hidden" padding="small 0 small large">
        <PreviewTemplateChart
          bindto={"preview-section-" + key1 + "-measure-" + key2 + "-overall"}
          masteryResults={"true"}
          title={t("assessment.masteryAvgOverall")}
        />
      </Flex.Item>
    </Flex>
  );
};

export default FlexibleAssessmentPreview;
